import React from 'react'
import { TableHeadProps } from './types'

const TableHead = ({ fields = [] }: TableHeadProps): JSX.Element => {
    return (
        <thead>
            <tr>
                {fields.map(field => {
                    return (
                        <th>
                            <div style={{position: 'relative'}}>{field}</div>
                        </th>
                    )
                })}
                <th>
                    <div style={{position: 'relative'}}>ENDEREÇO</div>
                </th>
                <th>
                    <div style={{position: 'relative'}}>CIDADE</div>
                </th>
                <th>
                    <div style={{position: 'relative'}}>ESTADO</div>
                </th>
            </tr>
        </thead>
    )
}
export default TableHead
